export const headers = [
  { name: 'Código', field: 'code', sortable: true },
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Criado por', field: 'createdUser.name', sortable: true },
  { name: 'Cadastrado Em', field: 'created_at', sortable: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
